import React from "react";
import { gql } from "@apollo/client";
import { List, Row, Col, FloatButton, notification, Divider } from "antd";
import { client } from "../App";
import prettyDateString from "../lib/prettyDateString";
import argoLink from "../lib/argoLink";
import { CreateMigrationRunButton } from "./CreateMigrationRunButton";
import { statusIcon } from "../lib/status";
import InfiniteList from "./InfiniteList";
import { DEFAULT_FEED_QUERY_LIMIT } from "../lib/pagination";

export const MIGRATION_RUN_FEED_QUERY = gql`
  query migrationFeed($offset: Int, $limit: Int, $queryString: String) {
    migrationFeed(offset: $offset, limit: $limit, queryString: $queryString) {
      migrations {
        id
        name
        status
        scheduledStartTime
        argoWorkflowId
        project {
          id
          company
        }
      }
      totalCount
      offset
      limit
      queryString
    }
  }
`;

export const DELETE_MIGRATION_RUN_MUTATION = gql`
  mutation deleteMigration($id: ID!) {
    deleteMigration(id: $id) {
      id
    }
  }
`;

export const SEND_MIGRATION_RUN_CLIENT_EMAIL_MUTATION = gql`
  mutation sendMigrationRunClientEmail($id: ID!) {
    sendMigrationRunClientEmail(id: $id) {
      id
    }
  }
`;

export async function deleteMigrationRun(e) {
  const migrationRunId = e.currentTarget.dataset.migrationRunId;
  client
    .mutate({
      mutation: DELETE_MIGRATION_RUN_MUTATION,
      variables: { id: migrationRunId },
    })
    .then(() => {
      notification["success"]({
        message: "Successfully deleted Migration Run",
      });
    })
    .catch((err) => {
      notification["error"]({
        message: "Failed to delete Migration Run",
        description: err.message,
      });
    });
}

export async function sendMigrationRunClientEmail(e) {
  const migrationRunId = e.currentTarget.dataset.migrationRunId;
  client
    .mutate({
      mutation: SEND_MIGRATION_RUN_CLIENT_EMAIL_MUTATION,
      variables: { id: migrationRunId },
    })
    .then(() => {
      notification["success"]({
        message: "Successfully scheduled Migration Run client email to be sent",
      });
    })
    .catch((err) => {
      notification["error"]({
        message: "Failed to schedule Migration Run email to be sent",
        description: err.message,
      });
    });
}

export function migrationRunListContent(migration: any) {
  return (
    <Row align="top">
      <Col span={2}>{statusIcon(migration.status, "large")}</Col>

      <Col span={22}>
        <Row align="top">
          <Col span={3}>
            <b>Status</b>
          </Col>
          <Col span={5}>
            <b>Scheduled Start Time</b>
          </Col>
          {migration.project && (
            <Col span={3}>
              <b>Migration</b>
            </Col>
          )}
          <Col span={8}>
            <b>Argo Workflow ID</b>
          </Col>
        </Row>
        <Row align="top">
          <Col span={3}>{migration.status}</Col>
          <Col span={5}>{prettyDateString(migration.scheduledStartTime)}</Col>
          {migration.project && (
            <Col span={3}>
              <a href={`/migrations/${migration.project.id}`}>
                {migration.project.company}
              </a>
            </Col>
          )}
          <Col span={8}>{argoLink(migration.argoWorkflowId)}</Col>
        </Row>
      </Col>
    </Row>
  );
}

const MigrationRunList = () => {
  return (
    <div>
      <FloatButton.BackTop />
      <h1 style={{ float: "left" }}>Migration Runs</h1>
      <div style={{ float: "right" }}>
        <CreateMigrationRunButton buttonText="Create New Migration Run" />
      </div>
      <Divider />
      <InfiniteList
        query={MIGRATION_RUN_FEED_QUERY}
        recordKey="migrations"
        perPage={DEFAULT_FEED_QUERY_LIMIT}
        showSearch={true}
        pollInterval={1000}
        listProps={{
          itemLayout: "vertical",
        }}
        renderListItem={(migration: any) => (
          <List.Item key={migration.id} actions={[]}>
            <List.Item.Meta
              title={
                <a
                  href={`/migration-runs/${migration.id}`}
                >{`Migration Run # ${migration.id} - ${migration.name}`}</a>
              }
            />
            {migrationRunListContent(migration)}
          </List.Item>
        )}
      />
    </div>
  );
};

export default MigrationRunList;
